import api from "./api";

/**
 * The client for the per-account usage switch (#1109, D218, D220 Q8a):
 *
 *   GET /api/usage/preference  -> { enabled, counted, opted_out }
 *   PUT /api/usage/preference  { opted_out }  -> the same shape
 *
 * THE SERVER IS THE ONLY SOURCE OF TRUTH. Nothing here caches a choice in
 * browser storage: the switch is read from the server on every mount, and
 * `publish` carries what the server answered, never what the person tapped.
 * That is what makes "the switch shows off while the server still counts"
 * unreachable by a failed `PUT` (the caller keeps the old value) or by a
 * stale read in a second tab (the next read is the server's).
 *
 * `subscribe`/`publish` exist so the tracker (#1110) learns of a change
 * without a reload. A listener that throws never stops another one.
 */

const listeners = new Set();

export async function fetchUsagePreference() {
  const res = await api.get("/usage/preference");
  return res.data;
}

export async function setUsageOptOut(optedOut) {
  const res = await api.put("/usage/preference", { opted_out: Boolean(optedOut) });
  return res.data;
}

/** Returns an unsubscribe function. */
export function subscribe(fn) {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

export function publish(pref) {
  for (const fn of [...listeners]) {
    try {
      fn(pref);
    } catch {
      // One listener's failure must not hide a change from the others.
    }
  }
}
